<script>
import { useVuelidate } from '@vuelidate/core'
import { email, helpers, required } from '@vuelidate/validators'
import { reactive } from 'vue'
import InputField from '@/components/input/InputField.vue'
import BoutonFormAuth from '@/components/bouton/BoutonFormAuth.vue'
import { api } from '@/modules/api'
import { useAuthStore } from '@/stores/auth'
import { mapStores } from 'pinia'
import Cookies from 'js-cookie'
import ModalResetPassword from "@/components/auth/ModalResetPassword.vue";

export default {
  name: 'LoginForm',
  components: {ModalResetPassword, BoutonFormAuth, InputField },
  setup() {
    const dataForm = reactive({
      email: '',
      password: ''
    });

    const rules = {
      dataForm: {
        email: {
          required: helpers.withMessage('Ce champs est obligatoire', required),
          email: helpers.withMessage('Le format de l\'email n\'est pas valide', email)
        },
        password: { required: helpers.withMessage('Ce champs est obligatoire', required) }
      }
    };

    const v$ = useVuelidate(rules, { dataForm })

    return { dataForm, v$ }
  },
  data () {
    return {
      isLoading: false,
      error: null,
      viewModal: false
    }
  },
  computed: {
    ...mapStores(useAuthStore),
  },
  methods: {
    submit () {
      this.isLoading = true
      this.v$.$touch();
      if (this.v$.$invalid) {
        this.isLoading = false
        return;
      }

      api.auth.login(this.dataForm).then((response) => {
        console.log(response)
        if (response.status === 401) {
          console.log('toto')
          this.error = response.response.data.message
          this.isLoading = false
          return
        }
        this.authStore.setToken(response.token)
        this.authStore.setUser(response.user)
        Cookies.set('token', response.token, { expires: 7 })
        Cookies.set('user', JSON.stringify(response.user), { expires: 7 })
        if (this.$route.query.next) {
          this.$router.push(this.$route.query.next)
          return
        }
        this.$router.push({name: 'app_home'})
      }).finally(() => {
        this.isLoading = false
      })
    }
  }
}
</script>

<template>
  <div class="space-y-4 md:space-y-6">
    <modal-reset-password v-if="viewModal" @close-modal="viewModal = false" />
    <p class="mt-2 text-sm text-red-600 dark:text-red-500">
      {{ error }}
    </p>
    <input-field
        label="Email"
        v-model="dataForm.email"
        type="email"
        placeholder="example@email.com"
        :validation="v$.dataForm.email"
    />
    <input-field
        label="Mot de passe"
        v-model="dataForm.password"
        type="password"
        placeholder="••••••••"
        :validation="v$.dataForm.password"
    />
    <div class="flex items-center">
      <button @click="viewModal = true" class="text-sm font-medium text-primary-700 hover:underline">
        Mot de passe oublié?
      </button>
    </div>
    <bouton-form-auth :is-loading="isLoading" @click="submit" />
    <p class="text-sm font-light text-gray-500 dark:text-gray-400">
      Pas de compte?
      <router-link  :to="{ name: 'app_register' }" class="font-medium text-primary-700 hover:underline dark:text-primary-500">S'inscrire</router-link>
    </p>
  </div>
</template>
